import { axiosInstance as axios } from "@/utils/wd_axios.js";
import {userKeys, wdConfigData, language_codes} from "@/service/wd_app_config.js"

export const api_content_edit = (params) => {
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var requestBody = {
    TaskType: params.taskType,
    Body: params.EmailBody,
    TextLength: params.TextLength,
    WriteStyle: params.WriteStyle,
    LcId: language_codes.ZH // Default to Chinese
  };
  var url = `${wdConfigData.baseURLApi}/ppt/Edit`;
  return axios.post(url, requestBody, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/json",
    },
  });
};
